// extracted by mini-css-extract-plugin
module.exports = {"columns":"columns","is-multiline":"is-multiline","column":"column","column-main":"column-main","column-sub":"column-sub","column-full":"column-full"};